import React from 'react';

import useFormFields from './hooks/useFormFields';
import useForm from './hooks/useForm';

export default function CrudForm({
  fields,
  submitButtonLabel,
  data,
  onSubmitFinish,
  createHandler,
  disabled,
  updateHandler,
  isPending,
}) {
  const formik = useForm({
    createHandler,
    updateHandler,
    serverData: data,
    fields,
    onSubmitFinish,
  });

  const formFields = useFormFields(fields, formik, disabled);

  // console.log(formik.values);

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className="grid gap-4 sm:grid-cols-2 sm:gap-6">{formFields}</div>
      {!disabled && (
        <button
          disabled={disabled || isPending}
          type="submit"
          className="inline-flex items-center px-5 py-2.5 mt-4 sm:mt-6 text-sm font-medium text-center text-white bg-primary-700 rounded-lg focus:ring-4 focus:ring-primary-200 dark:focus:ring-primary-900 hover:bg-primary-800 cursor-pointer"
        >
          {submitButtonLabel}
        </button>
      )}
    </form>
  );
}
